import { compose, setDisplayName, withProps } from 'recompose'
import { getCurrentSearchParams } from 'src/helpers/browser'

const withQueryParams = compose(
  setDisplayName('withQueryParams'),
  withProps(getCurrentSearchParams())
)

export default withQueryParams
